export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/062e30a7ac6b62636e98a277a6442dbf.svg";